import React from "react";
import { X, Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next"; // Pridėta i18n biblioteka

export default function DeletionModal({ 
  show, 
  onClose, 
  workerName, 
  projects, 
  onDelete 
}) {
  const { t } = useTranslation(); // Inicijuojame vertimus viduje

  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div 
        className="project-view-modal" 
        style={{ maxWidth: '400px', padding: '20px' }} 
        onClick={e => e.stopPropagation()}
      >
        <div className="modal-header" style={{ marginBottom: 0 }}>
          <h3 style={{ color: '#fff', fontSize: '18px', margin: 0 }}>
            {/* Pataisyta antraštė geresniam vertimui */}
            {t('remove_from_project')} - {workerName}
          </h3>
          <button className="close-x" onClick={onClose}><X size={24}/></button>
        </div>

        <div className="modal-body" style={{ padding: '20px 0' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {projects.length === 0 ? (
              /* Pridėta žinutė, jei projektų nėra */
              <p style={{ color: '#888', textAlign: 'center' }}>{t('no_projects_found')}</p>
            ) : (
              projects.map(p => (
                <button 
                  key={p.id} 
                  onClick={() => onDelete(p.id)} 
                  style={{ 
                    background: '#1c222e', 
                    border: '1px solid #4a5568', 
                    color: '#fff', 
                    padding: '12px', 
                    borderRadius: '8px', 
                    cursor: 'pointer', 
                    textAlign: 'left', 
                    fontWeight: 'bold', 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center' 
                  }}
                >
                  {/* bauvorhaben yra duomenų laukas, jo neverčiame */}
                  <span>{p.info.bauvorhaben}</span>
                  <Trash2 size={16} color="#ff3b3b"/>
                </button>
              ))
            )}
          </div>
        </div>

        {/* Galima pridėti uždarymo mygtuką apačioje dėl UX, jei norėtum */}
        <div style={{ marginTop: '10px' }}>
          <button 
            onClick={onClose} 
            style={{ 
              width: '100%', 
              padding: '10px', 
              background: 'transparent', 
              border: '1px solid #444', 
              color: '#888', 
              borderRadius: '8px',
              cursor: 'pointer'
            }}
          >
            {t('close')}
          </button>
        </div>
      </div>
    </div>
  );
}